import React from 'react'
import {Offer} from '../../types'

export interface CancellationPolicyProps {
  offer: Offer
}

const CancellationPolicy = ({offer}: CancellationPolicyProps) => {
  return (
    <div>
      <h3 className="font-semibold text-base border-b mb-2">
        Cancellation Policy
      </h3>
      <p
        dangerouslySetInnerHTML={{__html: offer?.cancellationFee?.description}}
      />
    </div>
  )
}

export default CancellationPolicy
